import { combineReducers } from 'redux';
import {
  FETCH_PRODUCT_C14S,
  RESET_C14S,
  productC14sError,
  productC14sLoading,
  productC14sReducer,
} from './ducks/product-charactristics';

export * from './types';
export { FETCH_PRODUCT_C14S, RESET_C14S };
export { DATA_QA_PDP_C14S_SECTION } from './components/pdp-c14s-section';

export const productC14sActions = {
  RESET_C14S,
  FETCH_PRODUCT_C14S,
};

export const productC14s = combineReducers({
  data: productC14sReducer,
  productC14sError,
  productC14sLoading,
});
